/* eslint-disable  */
import React from 'react';
import {
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography
} from '@material-ui/core';
import { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userinfo } from 'feactures/user/userSlice';
import { errorResMessage, setError } from 'feactures/errorSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { currentchannelName } from 'feactures/channel/channelSlice';
import {
  fetchKeywordList,
  performanceSeoLoading,
  fetchRegisterSeoKeyword
} from 'feactures/performancereview/performancereviewSlice';

const SeoKeywordRegisterDialog = ({ compareType, open, onClose, title }) => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [inputWord, setInputWord] = useState('');
  const errorMessage = useSelector(errorResMessage);
  const channelName = useSelector(currentchannelName);
  const seoLoading = useSelector(performanceSeoLoading);
  const userInfo = useSelector(userinfo);

  const handleChangeWord = (e) => {
    let word = e.target.value;
    word = word
      .replace(/、/g, ',') // 全角読点をカンマに
      .replace(/\u3000/g, ' ') // 全角スペースを半角に
      .replace(/ +/g, ' ') // 半角スペースが2つ以上 → 1つにする
      .replace(/,+/g, ','); // カンマ連続を1つに
    setInputWord(word);
  };

  const handleRegister = async () => {
    dispatch(setError(''));
    let trimWord = inputWord.trim();
    const wordArray = String(trimWord)
      .split(',')
      .map((word) => word.trim()) // 各キーワードをトリム
      .filter((word) => word); // 空文字を除外（もし連続カンマがあった場合）
    await dispatch(fetchRegisterSeoKeyword({ keyword: wordArray }));
    await dispatch(
      fetchRegisterSeoKeyword({
        keyword: wordArray,
        compareType: compareType
      })
    )
      .then(unwrapResult) //registerProductsで登録が成功（fullfilled）のときはモーダルを閉じる
      .then(() => {
        dispatch(fetchKeywordList('own'));
        dispatch(fetchKeywordList('other'));
        setInputWord('');
        setTimeout(() => {
          window.alert('キーワード登録が完了しました');
        }, 0);
        onClose();
      })
      .catch((err) => {
        setInputWord(inputWord);
      });
    // }
  };
  const handleClose = () => {
    onClose(); // ダイアログを閉じる
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: '500px'
          }
        }}
      >
        <DialogTitle>
          <Typography
            fontWeight="bold"
            fontSize="14px"
            mb={2}
            color="text.main"
          >
            2.検索＞{title}＞キーワード登録（
            {compareType == 'own' ? '自社' : '競合'}）
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography fontWeight={'bold'}>
            新しいキーワードを入力してください
          </Typography>
          <Typography>
            ・複数登録する場合は「,（カンマ）」で区切ってください
            <br />
            ・スペースを含めて複合キーワードも登録できます
            <br />
            　例：夏用 シャツ, メンズ 白 シャツ, オーバーサイズ Tシャツ
            <br />
            <br />
          </Typography>
          <Typography color="error" fontWeight={600}>
            ※最大{userInfo.plan[channelName].premium ? '5' : '1'}
            つまで登録可能
          </Typography>
          <form
            style={{ display: 'flex', flexDirection: 'row', width: '100%' }}
            onSubmit={(e) => {
              e.preventDefault();
              handleRegister();
            }}
          >
            <TextField
              placeholder="新しいキーワードを追加"
              inputRef={inputRef}
              value={inputWord}
              onChange={(e) => {
                handleChangeWord(e);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault(); // Enterの送信を防ぐ
                }
              }}
              inputProps={{
                style: { fontSize: '13px' }
              }}
              size="small"
              sx={{
                flexGrow: 1, // TextFieldを最大幅にする
                mr: '4px' // ボタンとの間に余白を確保
              }}
            />
            <Button
              type="submit"
              sx={{ minWidth: '50px', ml: 1 }}
              size="small"
              color="groupSelected"
              variant="contained"
              disabled={seoLoading}
            >
              追加
            </Button>
          </form>
          {errorMessage && <Typography color="red">{errorMessage}</Typography>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            とじる
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SeoKeywordRegisterDialog;
